import { ShoppingCart, Heart, ShoppingBag, Zap, MessageSquare, Handshake, Tag, Percent } from 'lucide-react';

/** Icon used inside a product action button (add to cart / buy now / negotiate).
 *  Shared between `ProductAddToCartBlock` (product page) and `BuilderProductCard`
 *  (Produkty grid) so both read the same `iconType` values consistently. */
export function ProductActionIcon({ iconType }: { iconType: string }) {
    if (iconType === 'heart') return <Heart className="h-4 w-4 shrink-0" />;
    if (iconType === 'bag') return <ShoppingBag className="h-4 w-4 shrink-0" />;
    if (iconType === 'cart') return <ShoppingCart className="h-4 w-4 shrink-0" />;
    if (iconType === 'zap') return <Zap className="h-4 w-4 shrink-0" />;
    if (iconType === 'message' || iconType === 'messagesquare') return <MessageSquare className="h-4 w-4 shrink-0" />;
    if (iconType === 'handshake') return <Handshake className="h-4 w-4 shrink-0" />;
    if (iconType === 'tag') return <Tag className="h-4 w-4 shrink-0" />;
    if (iconType === 'percent') return <Percent className="h-4 w-4 shrink-0" />;
    return null;
}
